import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import LoginPage from './components/login/LoginPage';
import LeadsPage from './components/leads/LeadsPage';
import LogoutPage from './components/LogoutPage';
import AllCustomers from './pages/customers/allcustomers';
import CustomerLoans from './pages/customers/customerloans';
import CustomerKYC from './pages/customers/customerkyc';
import AllCustomerLoans from './pages/customers/allcustomerloans';
import UserManagement from './pages/admin/UserManagement';
import RoleManagementPage from './pages/roles/RoleManagementPage';
import CustomerDetailsPage from './pages/customers/CustomerDetailsPage';
import AuditLogsPage from './pages/admin/AuditLogsPage';
import Dashboard from './pages/dashboard/Dashboard';
import DocumentViewerPage from './pages/customers/DocumentViewerPage';
import GenerateLeadPage from './pages/leads/GenerateLeadPage';
import LeadDetailsPage from './pages/leads/LeadDetailsPage';
import SearchLeadPage from './pages/leads/SearchLeadPage';
import AnchorDashboard from './pages/anchor/AnchorDashboard';
import AnchorInvoices from './pages/admin/AnchorInvoices';
import ViewAnchorsPage from './pages/admin/ViewAnchorsPage';
import PartnerDashboard from './pages/partner/PartnerDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import Unauthorized from './pages/Unauthorized';

function App() {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (message, type = 'info') => {
    const newNotification = {
      id: Date.now(), // Simple unique ID
      message,
      type,
      timestamp: new Date().toISOString(),
      read: false,
    };
    setNotifications(prevNotifications => [newNotification, ...prevNotifications]);
  };

  const markNotificationAsRead = (id) => {
    setNotifications(prevNotifications =>
      prevNotifications.map(notif =>
        notif.id === id ? { ...notif, read: true } : notif
      )
    );
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  return (
    <Router>
      <AppContent
        notifications={notifications}
        addNotification={addNotification}
        markNotificationAsRead={markNotificationAsRead}
        clearNotifications={clearNotifications}
      />
    </Router>
  );
}

function AppContent({ notifications, addNotification, markNotificationAsRead, clearNotifications }) {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  return (
    <>
      {!isLoginPage && <Header notifications={notifications} markNotificationAsRead={markNotificationAsRead} clearNotifications={clearNotifications} />}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute requiredPermission="View Reports">
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/leads" element={
          <ProtectedRoute requiredPermission="View Leads">
            <LeadsPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/anchors" element={
          <ProtectedRoute requiredPermission="View Anchors">
            <ViewAnchorsPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/customers" element={
          <ProtectedRoute requiredPermission="View Leads">
            <AllCustomers addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/customer/loans/:customerId" element={<CustomerLoans />} />
        <Route path="/customer/kyc/:customerId" element={<CustomerKYC />} />
        <Route path="/customer/allloans/:mobile" element={<AllCustomerLoans />} />
        <Route path="/admin/users" element={
          <ProtectedRoute requiredPermission="Manage Users">
            <UserManagement addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/admin/roles" element={
          <ProtectedRoute requiredPermission="Manage Roles">
            <RoleManagementPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/admin/audit-logs" element={
          <ProtectedRoute requiredPermission="View Reports">
            <AuditLogsPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/customers/:customerId" element={
          <ProtectedRoute requiredPermission="View Leads">
            <CustomerDetailsPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/document-viewer/:encodedUrl" element={<DocumentViewerPage />} />
        <Route path="/generate-lead" element={
          <ProtectedRoute requiredPermission="Generate Leads">
            <GenerateLeadPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/leads/:leadId" element={
          <ProtectedRoute requiredPermission="View Leads">
            <LeadDetailsPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/search-lead" element={
          <ProtectedRoute requiredPermission="View Leads">
            <SearchLeadPage addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/anchor/dashboard" element={
          <ProtectedRoute requiredPermission="View Reports">
            <AnchorDashboard addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/partner/dashboard" element={
          <ProtectedRoute requiredPermission="View Partner Dashboard">
            <PartnerDashboard addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/admin/anchor-invoices" element={
          <ProtectedRoute requiredPermission="View Invoices">
            <AnchorInvoices addNotification={addNotification} />
          </ProtectedRoute>
        } />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </>
  );
}

export default App;